import { AlertController, AlertButtonRole } from 'providers/alert-controller';
import { LL } from 'i18n/i18n.service';

/**
 * Tell the user that a food could not be READ right now — a connection problem or the
 * local database being busy — rather than that the food is missing. Shown wherever a
 * `FoodReadFailedError` is caught, so the user gets one honest, retryable message
 * instead of a silently wrong result.
 *
 * The wording lives in one place on purpose: several unrelated flows catch that error
 * (adding an ingredient, editing a meal, logging a scanned meal), and they should all
 * say the same thing. The strings already exist and are already translated, so this
 * adds no new i18n.
 */
export async function showFoodLoadFailedAlertAsync(alertCtrl: AlertController): Promise<void> {
  await alertCtrl.showAlertAsync<void>({
    title: LL.errors.userFacing.foodLoadFailedTitle(),
    message: LL.errors.userFacing.foodLoadFailed(),
    buttons: [
      {
        text: LL.common.buttons.ok(),
        role: AlertButtonRole.Primary,
      },
    ],
  });
}
